module.exports = __webpack_public_path__ + "img/z2.a61d871b.png";